module.exports = __webpack_public_path__ + "static/media/logo-new.765080a9.png";